const Hero = () => (
  <section id="top" className="pt-12 pb-20 border-b border-[#E7E5E4]">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-7 space-y-6">
        <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded bg-stone-200/70 text-stone-800 text-xs font-mono-ui">
          <span>MEMO // AUTO BODY DISPUTE AUTOMATION</span>
        </div>
        <h1 className="text-4xl sm:text-6xl font-normal tracking-tight text-[#1C1917] font-serif-display leading-[1.05]">
          <span className="reveal-line">
            <span>Every dollar owed by insurers,</span>
          </span>
          <span className="reveal-line">
            <span className="italic text-[#9A3412]">recovered with one tap.</span>
          </span>
        </h1>
        <p className="text-base sm:text-lg text-stone-600 leading-relaxed max-w-xl">
          Brim's agents read the carrier's estimate, draft every cited response,
          and track each round to payment. You approve with one tap — everything
          is sent under your shop's name.
        </p>
        <div className="pt-2 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <a
            href="#interest-form"
            data-testid="hero-claim-onboarding-btn"
            className="px-8 py-3.5 text-xs font-bold uppercase tracking-widest text-white bg-[#9A3412] hover:bg-[#7C2D12] rounded shadow-sm transition-colors"
          >
            Claim Shop Onboarding
          </a>
          <span className="text-xs text-stone-500 font-mono-ui">
            30-second setup • No software install
          </span>
        </div>
        <p className="text-xs text-stone-500 font-mono-ui pt-1">
          Reads CCC, Mitchell and Audatex — CCC / MOTOR · Mitchell · Audatex · DEG precedent · OEM procedures
        </p>
      </div>

      <div className="lg:col-span-5">
        <div
          data-testid="hero-claim-dossier"
          className="rounded-xl border border-stone-300 bg-white p-6 shadow-md relative overflow-hidden"
        >
          <div className="text-xs font-mono-ui uppercase text-stone-400 mb-4 pb-2 border-b border-stone-200 flex justify-between">
            <span>CLAIM DOSSIER</span>
            <span className="text-emerald-700 font-bold">STATUS: RECOVERED</span>
          </div>
          <div className="space-y-4 text-xs font-mono-ui">
            <div className="text-stone-500">
              2023 Genesis GV60 Advanced AWD · State Farm · Round 1 of supplement
            </div>
            <div>
              <div className="text-stone-500">CARRIER DISPUTED ITEM</div>
              <div className="font-bold text-stone-900 mt-0.5">
                Seam Sealer Application (Rear Quarter Panel)
              </div>
            </div>
            <div className="bg-stone-50 p-3 rounded border border-stone-200">
              <div className="text-stone-500 mb-1">CITED OEM STANDARD</div>
              <div className="text-stone-800 leading-snug">
                "Per Genesis Tech Procedure #60-82B, seam sealing must replicate
                factory bead width to maintain structural NVH and corrosion
                warranty."
              </div>
            </div>
            <div className="flex justify-between items-center pt-2 border-t border-stone-200">
              <span className="text-stone-600">
                Disputed Cut: <strong className="text-stone-900">$142.50</strong>
              </span>
              <span className="px-2 py-0.5 bg-emerald-100 text-emerald-800 rounded font-bold">
                Paid by State Farm
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
